import { IconButton } from 'components/Buttons';
import Constants from 'config/Constants';
import { set } from 'features/app/appSlice';
import { get } from 'lodash';
import { useGetDocument } from 'pages/documents_v2/hooks/useGetDocument';
import { useGetDocumentVariants } from 'pages/documents_v2/hooks/useGetDocumentVariants.js';
import { useIsEditMode } from 'pages/documents_v2/hooks/useIsEditMode';
import { VariantsAsLabels } from 'pages/documents_v2/views/edit_area/blocks/VariantsAsLabels';
import { useGetActiveVariant } from 'pages/documents_v2/views/edit_area/hooks/useGetActiveVariant';
import { idToUri } from 'pages/global/UriHelper';
import { entityTypes } from 'pages/translation/config/Constants';
import { PencilSquare } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

const emptyArray = [];

export function BlockVariants({ area, block }) {
    const document = useGetDocument();
    const dispatch = useDispatch();
    const { documentId, areaId } = useParams();
    const { t } = useTranslation();
    const isEditMode = useIsEditMode();
    const activeVariant = useGetActiveVariant();
    const documentVariants = useGetDocumentVariants();

    if (document.type === Constants.documentType.library || document.type === Constants.documentType.model) {
        return null;
    }

    const isTemplate = area?.properties?.isTemplate === true;
    const blockVariants = block.documentVariants ?? emptyArray;

    return (
        <div className="position-relative">
            <div className="d-flex align-items-baseline pt-4 pl-2">
                {isEditMode && !isTemplate && (
                    <IconButton
                        className="btn-icon-light mx-1"
                        tooltip={t('documents:document.navbar.main.editor.left.blocks.tooltips.editVariants')}
                        icon={<PencilSquare className="flex-shrink-0" size={16} />}
                        onClick={handleSettingsIconClick}
                    />
                )}

                <div className="pl-2 pt-3">
                    <VariantsAsLabels
                        blockVariants={blockVariants}
                        areaVariants={area?.documentVariants ?? []}
                        documentVariants={documentVariants}
                        activeVariant={activeVariant}
                        isTemplate={isTemplate}
                        showLimit={get(document, 'properties.blockVariantsLimit', 30)}
                    />
                </div>
            </div>
        </div>
    );

    function handleSettingsIconClick() {
        dispatch(
            set({
                key: 'sidebarContext',
                value: {
                    type: 'sidebarSettings',
                    context: {
                        entity: block,
                        entityType: entityTypes.BLOCK,
                        documentId: parseInt(documentId),
                        areaId: parseInt(areaId),
                        uri: idToUri(block.id, entityTypes.BLOCK),
                        parentUri: idToUri(parseInt(documentId), entityTypes.DOCUMENT),
                        landingTab: 'variants',
                    },
                },
            }),
        );
    }
}
